var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative"},[(_vm.poll.choices.length > 0)?_c('pie-chart',{attrs:{"height":250,"width":250,"chartData":_vm.computedChartData,"options":_vm.options}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }